class CopyCouponCode extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector("[data-copy-button]");
    if (!this.button) return;

    this.copyText = this.dataset.copyText || "Copiar";
    this.copiedText = this.dataset.copiedText || "¡Copiado!";
    this.label = this.button.querySelector("[data-copy-label]");

    this.onCopy = this.onCopy.bind(this);
    this.button.addEventListener("click", this.onCopy);
  }

  disconnectedCallback() {
    this.button?.removeEventListener("click", this.onCopy);
  }

  async onCopy() {
    const code = this.dataset.code;
    if (!code || !this.label) return;

    try {
      await navigator.clipboard.writeText(code);
    } catch (error) {
      const textarea = document.createElement("textarea");
      textarea.value = code;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "absolute";
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    }

    this.label.textContent = this.copiedText;
    window.clearTimeout(this.resetTimeout);
    this.resetTimeout = window.setTimeout(() => {
      this.label.textContent = this.copyText;
    }, 2000);
  }
}

if (!customElements.get("copy-coupon-code")) {
  customElements.define("copy-coupon-code", CopyCouponCode);
}
